/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Button } from '@blueprintjs/core';
import { Sizes } from 'styles/variables-slykit';
import { alignedMinimalButton, HeaderMd } from 'styles/styledComponentUtils';

/**
 * Filter Facet Header
 * @param {string} title header text
 * @param {boolean} loading loading state
 * @param {function} onBackClick callback for the backbutton.
 * @param {function} onResetClick callback for the reset button
 */
export const FacetHeader = ({
	title = 'Filters',
	loading = false,
	onResetClick,
	onBackClick,
	...props
}) => {

	// STATELESS

	return (
		<div {...props}>
			{onBackClick != null && (
				<Button
					cy-test="all-filters"
					onClick={onBackClick}
					icon={'arrow-left'}
					intent={'primary'}
					minimal
					small
					text={'All Filters'}
					css={[alignedMinimalButton, backButton]}
				/>
			)}
			<div css={titleRow}>
				<HeaderMd>{title}</HeaderMd>
				<Button
					cy-test="reset-facets"
					onClick={onResetClick}
					loading={loading}
					// disabled={something} // TODO: should be disabled if at base state
					text={!loading && 'Reset All'}
					rightIcon={'reset'}
					css={alignedMinimalButton}
					minimal
					small
				/>
			</div>
		</div>
	);
};

const backButton = css`
	margin-bottom: ${Sizes.xsm};
`;

const titleRow = css`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
